export default (backInStock) => ({
  options: null,
  variantData: null,
  currentVariantId: null,
  currentVariantAvailable: false,
  showBackInStock: backInStock,
  currentVariantTitle: null,
  productUrl: null,
  section: null,
  available: true,
  addToCartText: null,
  soldOutText: null,
  sizeOptionText: null,
  chooseASize: false,
  productHandle: null,
  productId: null,
  variantInventoryQuantity: null,
  variants: [],

  initVariants(variant) {
    if (!variant) this.chooseASize = true;
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }

    // Always initialize store data on page load
    const urlParams = new URLSearchParams(window.location.search);
    const nostoParam = urlParams.get("nosto");
    const refSrcParam = urlParams.get("refSrc");
    const currentStoreData = Alpine.store("nostoState").data || {};

    // Set initial store data, preserving any existing data
    Alpine.store("nostoState").set({
      ...currentStoreData,
      attributionKey: currentStoreData.attributionKey || nostoParam || null,
      refSrc: currentStoreData.refSrc || refSrcParam || null,
    });

    console.log(
      "Initialized store data on page load:",
      Alpine.store("nostoState").data
    );

    if (!variant) {
      this.chooseASize = true;
      return;
    }

    this.updateOptions();
  },

  updateOptions(template) {
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );

    this.sizeOptionText = this.options[1];
    if (this.sizeOptionText === "ONESI") {
      this.sizeOptionText = "Onesize";
    }

    this.updateMasterId();
    this.updateVariantInput();

    if (template === "product") {
      this.updateURL();
    }
    this.renderProductInfo();
    this.chooseASize = false;

    // Get current store data
    const storeData = Alpine.store("nostoState").data || {};
    const variantId = this.getVariantData()
      .find(
        (variant) =>
          !variant.options
            .map((option, index) => this.options[index] === option)
            .includes(false)
      )
      ?.id?.toString();

    // Update store with new variant data
    Alpine.store("nostoState").set({
      ...storeData,
    });

    console.log("Updated store data:", Alpine.store("nostoState").data);
  },

  updateMasterId() {
    let variantObj = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.currentVariantId = variantObj.id;
    this.currentVariantAvailable = variantObj.available;
    this.currentVariantTitle = variantObj.title;
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  },

  updateURL() {
    console.log("updateURL called");
    const storeData = Alpine.store("nostoState").data || {};
    const variantId = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false)
    )?.id;

    if (!variantId) return;

    // Check if we are on a product page
    const isProductPage = window.location.pathname.includes("/products/");

    if (isProductPage) {
      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;

      // Check if refSrc or nosto exists in the URL
      const hasRefSrc = searchParams.has("refSrc");
      const hasNosto = searchParams.has("nosto");

      if (hasRefSrc || hasNosto) {
        // Handle refSrc parameter
        if (hasRefSrc) {
          const currentRefSrc = searchParams.get("refSrc");
          // Get the product ID (not variant ID) from the current variant
          const productId = this.getVariantData().find(
            (variant) => variant.id === variantId
          )?.product_id;

          // Only update refSrc if we have a product ID and it's different from current
          if (productId && currentRefSrc !== productId.toString()) {
            searchParams.set("refSrc", productId.toString());
          }
        }

        // Handle nosto parameter
        const currentNosto = searchParams.get("nosto");
        // Only update nosto if we have a new attribution key and it's different
        if (
          storeData.attributionKey &&
          currentNosto !== storeData.attributionKey
        ) {
          searchParams.set("nosto", storeData.attributionKey);
        }

        // Always update the variant parameter
        searchParams.set("variant", variantId);
        window.history.replaceState({}, "", currentUrl.toString());
      }
    } else if (storeData.attributionKey && !isProductPage) {
      // Use the original logic for simple variant URLs
      window.history.replaceState(
        {},
        "",
        `${this.productUrl}?nosto=${storeData.attributionKey}&variant=${variantId}`
      );
    } else {
      // Use the original logic for simple variant URLs
      window.history.replaceState(
        {},
        "",
        `${this.productUrl}?variant=${variantId}`
      );
    }

    // Update store with new variant data, but preserve currentUrl
    Alpine.store("nostoState").set({
      ...storeData,
    });
  },

  renderProductInfo() {
    fetch(`${this.productUrl}?variant=${this.currentVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.getElementById(`price-${this.section}`);
        const sourceQuickshop1 = html.getElementById(
          `price-qs1-${this.section}`
        );
        const sourceQuickshop2 = html.getElementById(
          `price-qs2-${this.section}`
        );
        const sourceCartNotice = html.getElementById(`cn-${this.section}`);
        const sourceAPrice = html.getElementById(`ap-${this.section}`);
        const sourceQuickshopAPrice = html.getElementsByName(
          `properties[_actualprice]`
        );

        const dest = document.getElementById(`price-${this.section}`);
        const destQuickshop1 = document.getElementById(
          `price-qs1-${this.section}`
        );
        const destQuickshop2 = document.getElementById(
          `price-qs2-${this.section}`
        );
        const destCartNotice = document.getElementById(`cn-${this.section}`);
        const destAPrice = document.getElementById(`ap-${this.section}`);
        const destQuickshopAPrice = document.getElementById(
          `ap-${this.section}`
        );

        // Update values
        if (source && dest) dest.innerHTML = source.innerHTML;
        if (sourceAPrice && destAPrice) destAPrice.value = sourceAPrice.value;
        if (sourceCartNotice && destCartNotice)
          destCartNotice.innerHTML = sourceCartNotice.innerHTML;
        if (sourceQuickshop1 && destQuickshop1)
          destQuickshop1.innerHTML = sourceQuickshop1.innerHTML;
        if (sourceQuickshop2 && destQuickshop2)
          destQuickshop2.innerHTML = sourceQuickshop1.innerHTML;

        if (sourceQuickshopAPrice && destQuickshopAPrice) {
          if (sourceQuickshopAPrice[0]) {
            destQuickshopAPrice.value = sourceQuickshopAPrice[0].value;
          }
        }

        this.updateSubmitButton();
      });
  },

  updateVariantInput() {
    const inputs = document.querySelectorAll('input[name="id"]');
    const selectedSize = document.querySelector("#selectedVariantSize");
    selectedSize.value = this.sizeOptionText;

    for (const input of inputs) {
      input.value = this.currentVariantId;
    }
  },

  isVariantAvailable(text) {
    const variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    const variant = variantData.find((variant) => variant.option2 === text);
    if (variant) {
      if (variant.available) {
        return true;
      }
      return false;
    }
  },

  updateSubmitButton() {
    const button = this.$refs.submitBtnWrapper.querySelector(
      "#add-to-cart-button"
    );
    button.dataset.scrollLabel = this.currentVariantAvailable
      ? this.addToCartText
      : this.soldOutText;
    button.disabled = !this.currentVariantAvailable && !this.showBackInStock;
  },

  setVariants(id, quantity, available) {
    this.variants.push({
      id: id,
      quantity: quantity,
      available: available,
    });
  },
});
